<!-- eslint-disable -->
<template lang="pug">
    div.multi-screen-buttons
        cs-button.multi-screen-buttons__elem(
            @click="$emit('checkMultiplayerAnswers')",
            v-if="params.slug !== 'FlashCards' && !params.dictation",
            :disabled="!checkAnswersReadyScreens"
        ) {{ $i18n.t('trainer.trainer_games_checkAnswers') }}
        cs-button.multi-screen-buttons__elem(
            @click="$emit('playAgain')",
            v-if="!params.dictation",
            :disabled="!playAgainReadyScreens"
        ) {{ $i18n.t('trainer.trainer_games_tryAgain') }}
        router-link.multi-screen-buttons__elem(:to="{name: 'dashboard'}")
            cs-button {{ $i18n.t('common.common_navigation_goToMain') }}
        router-link.multi-screen-buttons__elem(:to="{name: 'create:game', query: {slug: this.type}}")
            cs-button {{ $i18n.t('trainer.trainer_games_goToSettings') }}
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex'

    export default {
        props: {
            type: String,
            playAgainReadyScreens: Number,
            checkAnswersReadyScreens: Number
        },
        computed: {
            ...mapState({
                game: state => state.trainer.game,
                paramsArray: state => state.trainer.paramsArray
            }),
            params () {
                return this.game || (this.paramsArray && this.paramsArray[0]);
            },
            playersNumber () {
                return this.paramsArray ? this.paramsArray.length : 1;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .multi-screen-buttons {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        background-color: white;
        padding: 18px;
        &__elem {
            width: 100%;
            @include stack-space($space-small);
            .cs-button {
                width: 100%;
            }
            @include media($lg) {
                width: unset;
                @include stack-space(0);
                @include inline-space($space-x-small);
                .cs-button {
                    width: unset;
                }
            }
        }
    }
</style>
